/** The OIDC request state carried through the hosted UI and handed back on the callback. */
export interface SignInState {
  returnTo: string;
}

/** The page someone was trying to open when they were asked to sign in. */
export function signInState(location: Pick<Location, "pathname" | "search" | "hash">): SignInState {
  return { returnTo: `${location.pathname}${location.search}${location.hash}` };
}

/**
 * The same-origin path to land on after the callback. Anything that is not a plain path, such as
 * `//evil.example` or `https://…`, falls back to the root.
 */
export function returnPath(state: unknown): string {
  const returnTo =
    typeof state === "object" && state !== null && "returnTo" in state ? state.returnTo : undefined;
  if (typeof returnTo !== "string" || !returnTo.startsWith("/") || /^\/[/\\]/.test(returnTo)) return "/";
  if (/^\/auth\/callback([/?#]|$)/.test(returnTo)) return "/";
  return returnTo;
}
